import { Link, NavLink } from "react-router-dom";

const NAV = [
  { to: "/brands", label: "The brands", testId: "nav-brands-link" },
  { to: "/about", label: "About", testId: "nav-about-link" },
  { to: "/contact", label: "Contact", testId: "nav-contact-link" },
];

export const Header = () => (
  <header
    data-testid="site-header"
    className="sticky top-0 z-50 bg-[#F4F3EF]/90 backdrop-blur-md border-b border-[#1A1C23]/10"
  >
    <div className="max-w-6xl mx-auto px-6 sm:px-10 h-16 sm:h-20 flex items-center justify-between gap-6">
      <Link
        to="/"
        data-testid="nav-home-link"
        className="flex items-center group"
        aria-label="Antelli — home"
      >
        <img
          src="/logo-lockup.png"
          alt="Antelli"
          className="h-8 sm:h-10 w-auto mix-blend-multiply transition-opacity duration-300 group-hover:opacity-80"
        />
      </Link>
      <nav className="flex items-center gap-4 sm:gap-9" aria-label="Primary">
        {NAV.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            data-testid={item.testId}
            className={({ isActive }) =>
              `text-[13px] sm:text-sm tracking-wide whitespace-nowrap transition-colors duration-300 ${
                isActive
                  ? "text-[#7A6034]"
                  : "text-[#4A4D57] hover:text-[#1A1C23]"
              }`
            }
          >
            {item.label}
          </NavLink>
        ))}
      </nav>
    </div>
  </header>
);
